import transformInaccessibleFilters from "search-filter/logic/transformInaccessibleFilters";
import createSearch from "views/logic/slices/createSearch";
const transformInaccessibleFiltersInQueries = (queries, isPermitted) => queries.map((query) => {
  const updatedFilters = transformInaccessibleFilters(query.filters, isPermitted);
  return query.toBuilder().filters(updatedFilters.toList()).build();
});
const transformInaccessibleFiltersInSearch = async (view, isPermitted) => {
  const updatedQueries = transformInaccessibleFiltersInQueries(view.search.queries, isPermitted);
  const newSearchWithNewId = await createSearch(view.search.toBuilder().queries(updatedQueries.toSet()).build());
  return view.toBuilder().search(newSearchWithNewId).build();
};
export default transformInaccessibleFiltersInSearch;
